module.exports = __webpack_public_path__ + "img/undraw_work_time_re_hdyv.f4274988.svg";